import { auth, functions } from "../../firebase/firebase";
import { httpsCallable } from "firebase/functions";
import moment from "moment-timezone";
import { TutorSchedule } from "../Types/TutorProfileSchema";

export function getTutorAvailableDays(tutorSchedule: TutorSchedule | undefined): string[] {
    var availableDays = [];
    if (tutorSchedule === undefined) {
        return [];
    }
    if (tutorSchedule.Sunday > 0) {
        availableDays.push("Sunday");
    }
    if (tutorSchedule.Monday > 0) {
        availableDays.push("Monday");
    }
    if (tutorSchedule.Tuesday > 0) {
        availableDays.push("Tuesday");
    }
    if (tutorSchedule.Wednesday > 0) {
        availableDays.push("Wednesday");
    }
    if (tutorSchedule.Thursday > 0) {
        availableDays.push("Thursday");
    }
    if (tutorSchedule.Friday > 0) {
        availableDays.push("Friday");
    }
    if (tutorSchedule.Saturday > 0) {
        availableDays.push("Saturday");
    }
    return availableDays;
}

export async function updateTutorSchedule(day: string, timeslot: number): Promise<void> {
    if (auth.currentUser == null) {
        throw new Error("No user is currently signed in.");
    }

    const updateTutorScheduleFunction = httpsCallable(functions, "updateTutorSchedule");

    await updateTutorScheduleFunction({
        day: day,
        timeslot: timeslot,
        TimeZone: moment.tz.guess()
    }).catch((error) => {
        throw new Error(error);
    });
}

export async function updateTutorScheduleTimeZone(timezone: string): Promise<void> {
    if (auth.currentUser == null) {
        throw new Error("No user is currently signed in.");
    }

    const updateTutorScheduleTimeZoneFunction = httpsCallable(functions, "updateTutorScheduleTimeZone");

    await updateTutorScheduleTimeZoneFunction({
        TimeZone: timezone
    }).catch((error) => {
        throw new Error(error);
    });
}